module.exports = __webpack_public_path__ + "static/img/fzlj.28f33ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fzlj.png
// module id = Ilz/
// module chunks = 0